import * as tslib_1 from "tslib";
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthActionTypes } from '../actions/auth.actions';
export var initialState = {
    user: null,
    roles: [],
    loginChallengeRequired: null,
    newPasswordRequired: null,
    completeFirstLogin: null,
    confirmNinetyDaysPassword: null,
    twoFAResend: null,
    updateUserName: null,
    forgotPassword: null,
    resetPassword: null,
    changePassword: null,
    enableMfa: null,
    mfaConfirm: null,
    mfaConfirmLogin: null,
    disableMfa: null,
    loading: [],
    errorMessage: null
};
export function Reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        // Start Login
        case AuthActionTypes.LOGIN: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case AuthActionTypes.LOGIN_SUCCESS: {
            return tslib_1.__assign({}, state, { user: action.payload.user, loading: clearLoading(state, AuthActionTypes.LOGIN), errorMessage: null });
        }
        case AuthActionTypes.LOGIN_FAILURE: {
            return tslib_1.__assign({}, state, { user: null, loading: clearLoading(state, AuthActionTypes.LOGIN), errorMessage: 'Incorrect username and/or password.' });
        }
        case AuthActionTypes.CLEAR_LOGIN: {
            return tslib_1.__assign({}, state, { user: null, loading: clearLoading(state, AuthActionTypes.LOGIN), errorMessage: null });
        }
        // End login
        // Start Get Current User
        case AuthActionTypes.GET_USER: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case AuthActionTypes.GET_USER_SUCCESS: {
            return tslib_1.__assign({}, state, { user: action.payload, loading: clearLoading(state, AuthActionTypes.GET_USER), errorMessage: null });
        }
        case AuthActionTypes.GET_USER_FAILURE: {
            return tslib_1.__assign({}, state, { user: null, loading: clearLoading(state, AuthActionTypes.GET_USER), errorMessage: 'No user' });
        }
        case AuthActionTypes.CLEAR_GET_USER: {
            return tslib_1.__assign({}, state, { user: null, loading: clearLoading(state, AuthActionTypes.GET_USER), errorMessage: null });
        }
        // End Get Current User
        // Start Login Challenge Required
        case AuthActionTypes.LOGIN_CHALLENGE_REQUIRED: {
            return tslib_1.__assign({}, state, { loginChallengeRequired: action.payload, loading: clearLoading(state, AuthActionTypes.LOGIN), errorMessage: null });
        }
        case AuthActionTypes.CLEAR_LOGIN_CHALLENGE_REQUIRED: {
            return tslib_1.__assign({}, state, { loginChallengeRequired: null, loading: clearLoading(state, AuthActionTypes.LOGIN_CHALLENGE_REQUIRED), errorMessage: null });
        }
        // End Login Challenge Required
        // Start Confirm Ninety Days Password
        case AuthActionTypes.CONFIRM_NINETY_DAYS_PASSWORD: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case AuthActionTypes.CONFIRM_NINETY_DAYS_PASSWORD_SUCCESS: {
            return tslib_1.__assign({}, state, { confirmNinetyDaysPassword: action.payload, loading: clearLoading(state, AuthActionTypes.CONFIRM_NINETY_DAYS_PASSWORD), errorMessage: null });
        }
        case AuthActionTypes.CONFIRM_NINETY_DAYS_PASSWORD_FAILURE: {
            return tslib_1.__assign({}, state, { confirmNinetyDaysPassword: null, loading: clearLoading(state, AuthActionTypes.CONFIRM_NINETY_DAYS_PASSWORD), errorMessage: 'Confirm ninety days password failed' });
        }
        case AuthActionTypes.CLEAR_CONFIRM_NINETY_DAYS_PASSWORD: {
            return tslib_1.__assign({}, state, { confirmNinetyDaysPassword: null, loading: clearLoading(state, AuthActionTypes.CONFIRM_NINETY_DAYS_PASSWORD), errorMessage: null });
        }
        // End Confirm Ninety Days Password
        // Start Forgot Password
        case AuthActionTypes.FORGOT_PASSWORD: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case AuthActionTypes.FORGOT_PASSWORD_SUCCESS: {
            return tslib_1.__assign({}, state, { forgotPassword: action.payload, loading: clearLoading(state, AuthActionTypes.FORGOT_PASSWORD), errorMessage: null });
        }
        case AuthActionTypes.FORGOT_PASSWORD_FAILURE: {
            return tslib_1.__assign({}, state, { forgotPassword: null, loading: clearLoading(state, AuthActionTypes.FORGOT_PASSWORD), errorMessage: 'Forgot password failed' });
        }
        case AuthActionTypes.CLEAR_FORGOT_PASSWORD: {
            return tslib_1.__assign({}, state, { forgotPassword: null, loading: clearLoading(state, AuthActionTypes.FORGOT_PASSWORD), errorMessage: null });
        }
        // End Forgot Password
        // Start Complete First Login
        case AuthActionTypes.COMPLETE_FIRST_LOGIN: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case AuthActionTypes.COMPLETE_FIRST_LOGIN_SUCCESS: {
            return tslib_1.__assign({}, state, { completeFirstLogin: action.payload, loading: clearLoading(state, AuthActionTypes.COMPLETE_FIRST_LOGIN), errorMessage: null });
        }
        case AuthActionTypes.COMPLETE_FIRST_LOGIN_FAILURE: {
            return tslib_1.__assign({}, state, { completeFirstLogin: null, loading: clearLoading(state, AuthActionTypes.COMPLETE_FIRST_LOGIN), errorMessage: 'Complete first login failed' });
        }
        case AuthActionTypes.CLEAR_COMPLETE_FIRST_LOGIN: {
            return tslib_1.__assign({}, state, { completeFirstLogin: null, loading: clearLoading(state, AuthActionTypes.COMPLETE_FIRST_LOGIN), errorMessage: null });
        }
        // End Complete First Login
        // Start Reset Password
        case AuthActionTypes.RESET_PASSWORD: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case AuthActionTypes.RESET_PASSWORD_SUCCESS: {
            return tslib_1.__assign({}, state, { resetPassword: action.payload, loading: clearLoading(state, AuthActionTypes.RESET_PASSWORD), errorMessage: null });
        }
        case AuthActionTypes.RESET_PASSWORD_FAILURE: {
            return tslib_1.__assign({}, state, { resetPassword: null, loading: clearLoading(state, AuthActionTypes.RESET_PASSWORD), errorMessage: 'Reset password failed' });
        }
        case AuthActionTypes.CLEAR_RESET_PASSWORD: {
            return tslib_1.__assign({}, state, { resetPassword: null, loading: clearLoading(state, AuthActionTypes.RESET_PASSWORD), errorMessage: null });
        }
        // End Reset Password
        // Start Change Password
        case AuthActionTypes.CHANGE_PASSWORD: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case AuthActionTypes.CHANGE_PASSWORD_SUCCESS: {
            return tslib_1.__assign({}, state, { changePassword: action.payload, loading: clearLoading(state, AuthActionTypes.CHANGE_PASSWORD), errorMessage: null });
        }
        case AuthActionTypes.CHANGE_PASSWORD_FAILURE: {
            return tslib_1.__assign({}, state, { changePassword: null, loading: clearLoading(state, AuthActionTypes.CHANGE_PASSWORD), errorMessage: 'Change password failed' });
        }
        case AuthActionTypes.CLEAR_CHANGE_PASSWORD: {
            return tslib_1.__assign({}, state, { changePassword: null, loading: clearLoading(state, AuthActionTypes.CHANGE_PASSWORD), errorMessage: null });
        }
        // End Change Password
        // Start Update User Name
        case AuthActionTypes.UPDATE_USER_NAME: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case AuthActionTypes.UPDATE_USER_NAME_SUCCESS: {
            return tslib_1.__assign({}, state, { updateUserName: action.payload, loading: clearLoading(state, AuthActionTypes.UPDATE_USER_NAME), errorMessage: null });
        }
        case AuthActionTypes.UPDATE_USER_NAME_FAILURE: {
            return tslib_1.__assign({}, state, { updateUserName: null, loading: clearLoading(state, AuthActionTypes.UPDATE_USER_NAME), errorMessage: 'Update username failed' });
        }
        case AuthActionTypes.CLEAR_UPDATE_USER_NAME: {
            return tslib_1.__assign({}, state, { updateUserName: null, loading: clearLoading(state, AuthActionTypes.UPDATE_USER_NAME), errorMessage: null });
        }
        // End Update User Name
        // Start Enable Mfa
        case AuthActionTypes.ENABLE_MFA: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case AuthActionTypes.ENABLE_MFA_SUCCESS: {
            return tslib_1.__assign({}, state, { enableMfa: action.payload, loading: clearLoading(state, AuthActionTypes.ENABLE_MFA), errorMessage: null });
        }
        case AuthActionTypes.ENABLE_MFA_FAILURE: {
            return tslib_1.__assign({}, state, { enableMfa: null, loading: clearLoading(state, AuthActionTypes.ENABLE_MFA), errorMessage: 'Enable Mfa failed' });
        }
        case AuthActionTypes.CLEAR_ENABLE_MFA: {
            return tslib_1.__assign({}, state, { enableMfa: null, loading: clearLoading(state, AuthActionTypes.ENABLE_MFA), errorMessage: null });
        }
        // End Enable Mfa
        // Start Mfa Confirm
        case AuthActionTypes.MFA_CONFIRM: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case AuthActionTypes.MFA_CONFIRM_SUCCESS: {
            return tslib_1.__assign({}, state, { mfaConfirm: action.payload, loading: clearLoading(state, AuthActionTypes.MFA_CONFIRM), errorMessage: null });
        }
        case AuthActionTypes.MFA_CONFIRM_FAILURE: {
            return tslib_1.__assign({}, state, { mfaConfirm: null, loading: clearLoading(state, AuthActionTypes.MFA_CONFIRM), errorMessage: 'Mfa confirm failed' });
        }
        case AuthActionTypes.CLEAR_MFA_CONFIRM: {
            return tslib_1.__assign({}, state, { mfaConfirm: null, loading: clearLoading(state, AuthActionTypes.MFA_CONFIRM), errorMessage: null });
        }
        // End Mfa Confirm
        // Start Mfa Confirm Login
        case AuthActionTypes.MFA_CONFIRM_LOGIN: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case AuthActionTypes.MFA_CONFIRM_LOGIN_SUCCESS: {
            return tslib_1.__assign({}, state, { mfaConfirmLogin: action.payload, loading: clearLoading(state, AuthActionTypes.MFA_CONFIRM_LOGIN), errorMessage: null });
        }
        case AuthActionTypes.MFA_CONFIRM_LOGIN_FAILURE: {
            return tslib_1.__assign({}, state, { mfaConfirmLogin: null, loading: clearLoading(state, AuthActionTypes.MFA_CONFIRM_LOGIN), errorMessage: 'Mfa confirm failed' });
        }
        case AuthActionTypes.CLEAR_MFA_CONFIRM_LOGIN: {
            return tslib_1.__assign({}, state, { mfaConfirmLogin: null, loading: clearLoading(state, AuthActionTypes.MFA_CONFIRM), errorMessage: null });
        }
        // End Mfa Confirm Login
        // Start Disable Mfa
        case AuthActionTypes.DISABLE_MFA: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case AuthActionTypes.DISABLE_MFA_SUCCESS: {
            return tslib_1.__assign({}, state, { disableMfa: action.payload, loading: clearLoading(state, AuthActionTypes.DISABLE_MFA), errorMessage: null });
        }
        case AuthActionTypes.DISABLE_MFA_FAILURE: {
            return tslib_1.__assign({}, state, { disableMfa: null, loading: clearLoading(state, AuthActionTypes.DISABLE_MFA), errorMessage: 'Disable Mfa failed' });
        }
        case AuthActionTypes.CLEAR_DISABLE_MFA: {
            return tslib_1.__assign({}, state, { disableMfa: null, loading: clearLoading(state, AuthActionTypes.DISABLE_MFA), errorMessage: null });
        }
        // End Disable Mfa
        // Logout
        case AuthActionTypes.LOGOUT: {
            return tslib_1.__assign({}, state, { user: null, errorMessage: null });
        }
        // Start Get User Roles
        case AuthActionTypes.GET_USER_ROLES: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case AuthActionTypes.GET_USER_ROLES_SUCCESS: {
            return tslib_1.__assign({}, state, { roles: action.payload, loading: clearLoading(state, AuthActionTypes.GET_USER_ROLES), errorMessage: null });
        }
        case AuthActionTypes.GET_USER_ROLES_FAILURE: {
            return tslib_1.__assign({}, state, { roles: null, loading: clearLoading(state, AuthActionTypes.GET_USER_ROLES), errorMessage: 'Get User Roles failed' });
        }
        case AuthActionTypes.CLEAR_GET_USER_ROLES: {
            return tslib_1.__assign({}, state, { roles: null, loading: clearLoading(state, AuthActionTypes.GET_USER_ROLES), errorMessage: null });
        }
        // End Get User Roles
        default: {
            return tslib_1.__assign({}, state);
        }
    }
}
// `createFeatureSelector` is for selecting a "Type"
// When reuqesting whole feature state, the app can call this const directly
// Selectors
var getAuth = createFeatureSelector('auth');
var ɵ0 = function (state) { return state.loginChallengeRequired; }, ɵ1 = function (state) { return state.newPasswordRequired; }, ɵ2 = function (state) { return state.completeFirstLogin; }, ɵ3 = function (state) { return state.confirmNinetyDaysPassword; }, ɵ4 = function (state) { return state.twoFAResend; }, ɵ5 = function (state) { return state.updateUserName; }, ɵ6 = function (state) { return state.forgotPassword; }, ɵ7 = function (state) { return state.resetPassword; }, ɵ8 = function (state) { return state.changePassword; }, ɵ9 = function (state) { return state.enableMfa; }, ɵ10 = function (state) { return state.mfaConfirm; }, ɵ11 = function (state) { return state.mfaConfirmLogin; }, ɵ12 = function (state) { return state.disableMfa; }, ɵ13 = function (state) { return state.user; }, ɵ14 = function (state) { return state.roles; }, ɵ15 = function (state) { return state.loading; };
export var Selectors = {
    getAuth: getAuth,
    loginChallengeRequired: createSelector(getAuth, ɵ0),
    newPasswordRequired: createSelector(getAuth, ɵ1),
    completeFirstLogin: createSelector(getAuth, ɵ2),
    confirmNinetyDaysPassword: createSelector(getAuth, ɵ3),
    twoFAResend: createSelector(getAuth, ɵ4),
    updateUserName: createSelector(getAuth, ɵ5),
    forgotPassword: createSelector(getAuth, ɵ6),
    resetPassword: createSelector(getAuth, ɵ7),
    changePassword: createSelector(getAuth, ɵ8),
    enableMfa: createSelector(getAuth, ɵ9),
    mfaConfirm: createSelector(getAuth, ɵ10),
    mfaConfirmLogin: createSelector(getAuth, ɵ11),
    disableMfa: createSelector(getAuth, ɵ12),
    getUser: createSelector(getAuth, ɵ13),
    getUserRoles: createSelector(getAuth, ɵ14),
    getLoading: createSelector(getAuth, ɵ15)
};
function clearLoading(authState, action) {
    return authState.loading.filter(function (loadingMarker) { return loadingMarker !== action; });
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15 };
